import SxDef from '@core/types/SxDef';

// Paper surface, radius and shadow come from the theme's MuiPopover pattern.
const useSx = (): SxDef => ({
  root: {
    // Header menus open just below the 64px navbar, whatever icon anchors them.
    '& .MuiMenu-paper': { top: '72px !important' },
    '& .MuiMenu-list': {
      minWidth: '14rem',
      maxWidth: '18rem',
    },
    '& .ListItemTitle': { whiteSpace: 'normal', '& span': { fontWeight: '900' } },
    '& .ListItemSubtitle': { whiteSpace: 'normal' },
    '& .ListItemDate': { '& span': { fontSize: '0.7rem' } },
    '& .ListItemCloseIcon': { position: 'absolute', top: '5px', right: '5px' },
    '& .MenuItem': { position: 'relative', '&:hover': { borderRadius: '10px' } },
  },
});

export default useSx;
